/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Create_TitleInputs */

const en_user_create_title = /** @type {(inputs: User_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create User`)
};

const ja_user_create_title = /** @type {(inputs: User_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーを作成`)
};

const fr_user_create_title = /** @type {(inputs: User_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un utilisateur`)
};

const de_user_create_title = /** @type {(inputs: User_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer erstellen`)
};

/**
* | output |
* | --- |
* | "Create User" |
*
* @param {User_Create_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_create_title = /** @type {((inputs?: User_Create_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Create_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_create_title(inputs)
	if (locale === "ja") return ja_user_create_title(inputs)
	if (locale === "fr") return fr_user_create_title(inputs)
	return de_user_create_title(inputs)
});